export default __webpack_public_path__ + "static/media/clockIcon.3a69382c.svg";